import { Component, Input } from '@angular/core';
import { EmployeeRequestEntity } from 'src/app/store/entity-models';

@Component({
    standalone: false,
    selector: 'app-request-additional-information-dropdown',
    templateUrl: './request-additional-information-dropdown.component.html',
    styleUrls: ['./request-additional-information-dropdown.component.scss']
})
export class RequestAdditionalInformationDropdownComponent {
    @Input() request: EmployeeRequestEntity;
}
